module.exports = __webpack_public_path__ + "media/images/ORANGE - MISIMO - Logotype-6195f8b1b6b05e47595cfad18492f03d.png";